import { Dispatch } from 'redux';
import {
  closeSuccessPromotionAlertModal,
  openFailurePaymentAlertModal,
  openFailureWebViewPaymentStatusAlertModal,
  openSuccessWebViewPaymentStatusAlertModal
} from '../../actions';

export const closeLegacyPaymentAlertModals = (dispatch: Dispatch) => {
  dispatch(openFailurePaymentAlertModal({ isVisible: false, name: '' }));
  dispatch(closeSuccessPromotionAlertModal());
};

export const dispatchWebViewSuccessPaymentStatus = (
  dispatch: Dispatch,
  params: Record<string, unknown>
) => {
  closeLegacyPaymentAlertModals(dispatch);
  dispatch(openSuccessWebViewPaymentStatusAlertModal(params));
};

export const dispatchWebViewFailurePaymentStatus = (
  dispatch: Dispatch,
  type: 'error' | 'warning' = 'error',
  errorMessage: string | null = null
) => {
  closeLegacyPaymentAlertModals(dispatch);
  dispatch(
    openFailureWebViewPaymentStatusAlertModal({
      isVisible: true,
      type,
      errorMessage
    })
  );
};
